import { useCallback, useState } from 'react';

type InstantRefValue<T> = T | null;
type InstantRefHookReturn<T> = [InstantRefValue<T>, (value: InstantRefValue<T>) => void];

export function useInstantRef<T>(): InstantRefHookReturn<T> {
    const [currentValue, setCurrentValue] = useState<InstantRefValue<T>>(null);
    const setRef = useCallback((value: InstantRefValue<T>) => setCurrentValue(value), []);

    return [currentValue, setRef];
}
